var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import login from 'root/src/client/logic/auth/thunks/login';
// Redesign email sign-in. Reuses the legacy `login` thunk but always supplies an `onSignIn`
// callback, so login authenticates (setSession + determineAuth) WITHOUT its post-login
// navigation - the dialog owns the success/close UX. The legacy `login` is left untouched.
export const signInWithEmail = ({ email, password, onSignIn }) => login({
    email,
    password,
    onSignIn: onSignIn !== null && onSignIn !== void 0 ? onSignIn : (() => __awaiter(void 0, void 0, void 0, function* () { return undefined; })),
});
